import { ClientAnalytics } from './clientAnalytics'

// Browse controls on the Available Challenges page: grouping segment control,
// the sort mode/direction in the filter rail, every filter facet, search,
// clear-all, the desktop filter panel toggle, and per-category collapse/expand.
export type ChallengeBrowseAnalyticsEvent =
  | 'challenges:group:change'
  | 'challenges:sort:mode'
  | 'challenges:sort:direction'
  | 'challenges:filter:toggle'
  | 'challenges:filter:search'
  | 'challenges:filter:clear'
  | 'challenges:filter:panel'
  | 'challenges:filter:resume_in_progress'
  | 'challenges:category:toggle'

// The full-screen "Help me pick" wizard funnel: open → three answers →
// result surfaced → start (the conversion), plus the side branches.
export type HelpMePickAnalyticsEvent =
  | 'helpMePick:open'
  | 'helpMePick:answer:intensity'
  | 'helpMePick:answer:tool'
  | 'helpMePick:answer:proficiencies'
  | 'helpMePick:results'
  | 'helpMePick:showAll'
  | 'helpMePick:resultShown'
  | 'helpMePick:start'
  | 'helpMePick:pickAnother'
  | 'helpMePick:backToMatches'
  | 'helpMePick:close'

export type ChallengesAnalyticsEvent =
  | ChallengeBrowseAnalyticsEvent
  | HelpMePickAnalyticsEvent

export function trackChallengeBrowse(
  event: ChallengeBrowseAnalyticsEvent,
  properties?: Record<string, unknown>
) {
  ClientAnalytics.track(event, properties)
}

export function trackHelpMePick(
  event: HelpMePickAnalyticsEvent,
  properties?: Record<string, unknown>
) {
  ClientAnalytics.track(event, properties)
}
